import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type RewardProgramFragment = { id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null };

export const RewardProgramFragmentDoc = gql`
    fragment RewardProgramFragment on RewardProgramType {
  id
  pk
  availableFrom
  availableTo
  coefficient
  dateCreated
  daysActive
  name
  description
  isActive
  rdThreshold
  rpThreshold
  thumbnailUrl(method: THUMBNAIL_WEBP, size: "300x0")
}
    `;